//
// README - Beta Component
//
// This component is marked "beta" and will go through some iterations
// before landing at a final solution. Please reach out to the Cadence team
// if you intend to use this in the meantime and we'll help you out!
//

import React from 'react';
import classNames from 'classnames';

import { RCIcon } from '../';

export interface RCNudgeProps {
  icon: (props: React.SVGProps<SVGElement>) => React.ReactElement;
  label?: string;
  hideLabel?: boolean;
}

export function RCNudge({
  icon,
  label,
  hideLabel = false,
}: RCNudgeProps) {
  return (
    <div className={classNames(
      'rc-nudge',
      {
        'rc-nudge--hidden-label': hideLabel,
      },
    )}>
      <div
        className="rc-nudge__icon"
        aria-label={label}
      >
        <RCIcon svgComponent={icon} />
      </div>
      <div
        className="rc-nudge__icon__label"
        aria-hidden
      >
        {label}
      </div>
    </div>
  );
}
